module.exports = __webpack_public_path__ + "img/bg12.f0de2475.jpg";